// extracted by mini-css-extract-plugin
module.exports = {"circular-btn":"_3371e3","circular-btn__btn":"_4d9481","circular-btn__btn_small":"_55e34d","circular-btn__text":"a44d8a"};